<template>
  <div class="flex h-100 scalein animation-duration-500">
    <div class="hidden md:block w-6 bg-no-repeat bg-cover" style="background-image: url('images/signin.jpg')"></div>
    <div class="surface-section w-full md:w-6 p-6 md:p-8">
      <div class="flex align-items-center justify-content-center">
        <img src="/images/navbarlogo.png" alt="Image" height="50" class="mb-5 flex align-items-center" @click="Home" style="cursor:pointer">
      </div>
      <div class="flex align-items-center justify-content-center">
        <span class="text-900 text-3xl font-medium mb-3">
          Welcome Back
        </span>
        </div>
      <div class="mb-5 flex align-items-center justify-content-center">
        <span class="text-600 font-medium mr-2">Don't have an account?</span>
        <a class="font-medium no-underline text-blue-500 cursor-pointer" @click="RouteTo('/Register')">Create today!</a>
      </div>
      <div>
        <Message severity="error" v-if="IsLoginFailure">{{FailureMessage}}</Message>
        <label for="email2" class="block text-900 font-medium mb-2">Email</label>
        <InputText id="email2" type="text" class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full" @blur="v$.Email.$validate()" v-model="state.Email" />
        <span v-if="v$.Email.$error" class="p-error m-1"> {{ v$.Email.$errors[0].$message }} </span>

        <label for="Password" class="block text-900 font-medium mb-2 mt-4">Password</label>
        <Password id="Password" :feedback="false" :toggleMask="true" @blur="v$.Password.$validate()" v-model="state.Password" inputClass="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
        </Password>
        <span v-if="v$.Password.$error" class="p-error mb-1"> {{ v$.Password.$errors[0].$message }} </span>

        <div class="flex align-items-center justify-content-between mb-6">
          <div class="flex align-items-center">
            <Checkbox id="rememberme2" :binary="true" v-model="RememberMe" class="mr-2"></Checkbox>
            <label for="rememberme2">Remember me</label>
          </div>
          <a class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer" @click="RouteTo('/ForgotPassword')">Forgot password?</a>
        </div>
        <Button iconPos="right" :label="BtnText" icon="pi pi-user" class="w-full p-md-3 text-white p-button-sm" :disabled="v$.$invalid" :loading="IsLoggingIn" @click="SignIn" style="color:white !important" size="small"/>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .p-inputwrapper {
    width: 100% !important;
  }

  .p-button {
    color: white;
    background: #ef7d1a !important;
  }

  .p-button:enabled:hover {
        background: #ff9800 !important;
        color: #ffffff;
        border-color: transparent;
      }

      .p-button:disabled {
        background-color: rgba(0, 0, 0, 0.12) !important;
        color: rgba(0, 0, 0, 0.38) !important;
        opacity: 1;
      }
</style>

<script>

  /* eslint-disable no-debugger */

  import Button from 'primevue/button';
  import InputText from 'primevue/inputtext';
  import Checkbox from 'primevue/checkbox';
  import useVuelidate from '@vuelidate/core'
  import { required, email, helpers } from '@vuelidate/validators'
  import { reactive, computed } from 'vue'
  import Password from 'primevue/password';
  import Message from 'primevue/message';
 

  export default {
    name: 'LoginHome',
    components: {
      Button,
      InputText,
      Checkbox,
      Password,
      Message
    },
    data: () => ({
      RememberMe: true,
      IsLoggingIn: false,
      BtnText: 'Sign In',
      FailureMessage: null,
      IsLoginFailure: false
    }),
    created() {
      this.$emit("set-nav", this.$route)
    },
    setup() {
  
      const state = reactive({
        Email: '',
        Password: ''
      })
      const rules = computed(() => {
        return {
          Email: {
            required: helpers.withMessage("Email Address Is Required", required), email: helpers.withMessage("Input Must Be A Valid Email Address", email) },
            Password: { required: helpers.withMessage("You Must Specify A Password", required)},
        }
      });

      const v$ = useVuelidate(rules, state)
      return { state, v$}
    },
    methods: {
      Home() {
        this.$router.push('/')
      },
      RouteTo(path) {
        this.$router.push({path:path})
      },
     SignIn() {

        var self = this;
        self.IsLoginFailure = false;
        self.IsLoggingIn = true;
        self.BtnText = "Signing In.."

        self.loginSuccess = true;

        self.$http.post('/Authorization/SignIn', { UserName: self.state.Email, Password: self.state.Password }).then(function (response) {
          if (response.data.success) {
            if (!response.data.isAuthenticated) {
              self.IsLoggingIn = false;
              self.IsLoginFailure = true;
              self.FailureMessage = response.data.message
              self.BtnText = "Sign In"
              self.state.Password = '';
              self.v$.Password.$reset();
            }
            else {
              self.stateData = {
                token: response.data.tokenization.token,
                userName: response.data.userName,
                isAuthenticated: true,
                role: response.data.role,
                organizationId: response.data.organizationId,
                id: response.data.id
              };
              self.$store.commit('SetAuth', self.stateData);
              var homePage = self.$store.getters.user.homepage;
              self.$router.push({ path: homePage })
            }
          }
          else {
            self.loginSuccess = false;
            self.IsLoggingIn = false
            self.state.Password = '';
          }
        })
      }
    }
  }
</script>